import { FulfillmentOrderRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class FulfillmentOrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderRouteService());
	}

	find(filter) {
		const url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	select(filter) {
		const url = this.routeService.select(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	getCloseoutOrders(filter) {
		const url = this.routeService.getCloseoutOrders(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	toggleProductionMode(id, productionMode, sourceOfChange) {
		const url = this.routeService.toggleProductionMode(id, productionMode, sourceOfChange);
		return this.apiClient.put(url);
	}

	getFulfillmentOrdersForLabeling = filter => {
		const url = this.routeService.getFulfillmentOrdersForLabeling(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	getFulfillmentOrderShipment = (upc, sourceOfChange) => {
		const url = this.routeService.getFulfillmentOrderShipment(upc, sourceOfChange);
		return this.apiClient.get(url);
	};

	countFulfillmentOrdersByStatus(filter) {
		const url = this.routeService.countFulfillmentOrdersByStatus(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	updateBuyShippingBulk(items, sourceOfChange) {
		const url = this.routeService.updateBuyShippingBulk(items, sourceOfChange);
		return this.apiClient.put(url, items);
	}

	cancelFulfillmentOrder(item, sourceOfChange) {
		const url = this.routeService.cancelFulfillmentOrder(item, sourceOfChange);
		return this.apiClient.put(url);
	}

	scanLabel(resource, sourceOfChange) {
		const url = this.routeService.scanLabel(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	onHold(onHoldParams, sourceOfChange) {
		const url = this.routeService.onHold(onHoldParams, sourceOfChange);
		return this.apiClient.post(url, onHoldParams);
	}

	onHoldBulk(onHoldBulkParams, sourceOfChange) {
		const url = this.routeService.onHoldBulk(onHoldBulkParams, sourceOfChange);
		return this.apiClient.post(url, onHoldBulkParams);
	}

	undoPackaged(undoPackageParams, sourceOfChange) {
		const url = this.routeService.undoPackaged(undoPackageParams, sourceOfChange);
		return this.apiClient.post(url, undoPackageParams);
	}

	createWarehouseOrders(fulfillmentOrderIds) {
		const url = this.routeService.createWarehouseOrders(fulfillmentOrderIds);
		return this.apiClient.post(url, fulfillmentOrderIds);
	}

	validateOrderAddress(order) {
		var url = this.routeService.validateOrderAddress(order);
		return this.apiClient.put(url, order);
	}

	reoptimize(reoptimizeParams, sourceOfChange) {
		const url = this.routeService.reoptimize(sourceOfChange);
		return this.apiClient.post(url, reoptimizeParams);
	}

	changeWarehouseShipByDate = async (payload, sourceOfChange) => {
		const url = this.routeService.changeWarehouseShipByDate(sourceOfChange);
		return this.apiClient.post(url, payload);
	};

	getDistinctValues(distinctSearchParams) {
		var url = this.routeService.getDistinctValues();
		return this.apiClient.post(url, distinctSearchParams);
	}
}

export default FulfillmentOrderService;



// WEBPACK FOOTER //
// ./src/common/data/services/FulfillmentOrderService.js